import $ from 'jquery';
import { pageLanguage } from '../util/common';
import GoogleMapsLoader from 'google-maps';

let google, autocomplete;

$(document).ready(() => {
  let $addressAutocompleter = $('.address-autocompleter input');
  let $zona = $('input[type=hidden][name=input_3]');
  
  if($addressAutocompleter.length > 0) {
    GoogleMapsLoader.KEY = 'AIzaSyDV6ctXXAASEZ3LnzX58eBjA9ANc5cg3MI';
    GoogleMapsLoader.LANGUAGE = pageLanguage();
    GoogleMapsLoader.LIBRARIES = ['places'];

    GoogleMapsLoader.load((g) => {
      
      google = g;
      let $city = $('.cities select');

      $city.prop('readonly', true);

      $addressAutocompleter.on('keypress', (e) => {
        var key = e.charCode || e.keyCode || 0;     
        if (key == 13) {
          e.preventDefault();
        }
      });

      // Create the autocomplete object, restricting the search predictions to
      // geographical location types.
      autocomplete = new google.maps.places.Autocomplete(
        $addressAutocompleter[0], {
          // types: ['geocode'],
          types: ['address'],
          componentRestrictions: {
            country: 'IT',
          }
        }
      );

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      // autocomplete.setFields([
      //   'address_component'
      // ]);

      $city.change(() => {
        // TODO: restrict search area
        // autocomplete.setComponentRestrictions({

        // });
      });

      var centerPolygonCoords = [
        { lat: 45.4673, lng: 9.19994 },
        { lat: 45.46983, lng: 9.19792 },
        { lat: 45.47212, lng: 9.19521 },
        { lat: 45.47281, lng: 9.1924 },
        { lat: 45.47314, lng: 9.18924 },
        { lat: 45.47257, lng: 9.18562 },
        { lat: 45.47163, lng: 9.18233 },
        { lat: 45.4683, lng: 9.1774 },
        { lat: 45.46568, lng: 9.17547 },
        { lat: 45.46142, lng: 9.17349 },
        { lat: 45.45787, lng: 9.17967 },
        { lat: 45.45613, lng: 9.18774 },
        { lat: 45.45759, lng: 9.1935 },
        { lat: 45.46221, lng: 9.198 },
        { lat: 45.46457, lng: 9.2 } 
      ];

      var centerPolygon = new google.maps.Polygon({paths: centerPolygonCoords});

      var semiCenterPolygonCoords = [
        { lat: 45.49865, lng: 9.16423 },
        { lat: 45.48325, lng: 9.1426 },
        { lat: 45.46426, lng: 9.1465 },
        { lat: 45.44623, lng: 9.15659 },
        { lat: 45.44376, lng: 9.16855 },
        { lat: 45.44323, lng: 9.18051 },
        { lat: 45.44601, lng: 9.18796 },
        { lat: 45.44725, lng: 9.21006 },
        { lat: 45.45604, lng: 9.21847 },
        { lat: 45.48577, lng: 9.21676 },
        { lat: 45.4917, lng: 9.20517 },
        { lat: 45.49418, lng: 9.19869 },
        { lat: 45.4957, lng: 9.19152 },
        { lat: 45.49718, lng: 9.17993 },
        { lat: 45.49671, lng: 9.17208 },
      ];

      var semiCenterPolygon = new google.maps.Polygon({paths: semiCenterPolygonCoords});

      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      autocomplete.addListener('place_changed', () => {
        // Get the place details from the autocomplete object.
        let place = autocomplete.getPlace();

        if(!place || !place.geometry || !place.geometry.location) {
          $zona.val('');
          return;
        }

        // console.debug('place', place, place.geometry.location.lat(), place.geometry.location.lng());

        // let city = !!place.address_components && !!place.address_components[1] ? place.address_components[1].long_name : '';
        // $city.val(city);
        // console.debug('city', city);

        let isCenter = false;
        let isSemiCenter = false;
        let isSuburb = false;

        isCenter = google.maps.geometry.poly.containsLocation(place.geometry.location, centerPolygon);

        if(isCenter) {
          $zona.val('centro');
        } else {
          isSemiCenter = google.maps.geometry.poly.containsLocation(place.geometry.location, semiCenterPolygon);

          if(isSemiCenter) {
            $zona.val('semi-centro');
          } else {
            isSuburb = true;
            $zona.val('periferia');
          }
        }

        // console.debug('isCenter, isSemiCenter, isSuburb', isCenter, isSemiCenter, isSuburb);
      });
    });

    $('form').submit(function() {
      if(!$zona.val()) {
        $addressAutocompleter.val('');
      }
    });
  }
});


// WEBPACK FOOTER //
// ./scripts/util/homeCurrency.js